class PlanQuizQuestion extends HTMLElement {
  constructor() {
    super();

    this.selectedOption = null;

    this.btn = this.querySelector('[data-next]');
    this.options = this.querySelectorAll('[data-option]');

    this.options.forEach((option) => {
      option.addEventListener('change', this.handleOptionChange.bind(this));
    });
  }

  handleOptionChange(e) {
    const { value } = e.target;
    this.selectedOption = value;
    this.updateButton();
  }

  reset() {
    this.selectedOption = null;

    this.options.forEach((input) => {
      input.checked = false;
    });

    this.updateButton();
  }

  updateButton() {
    if (this.validate()) {
      this.btn.removeAttribute('disabled');
    } else {
      this.btn.setAttribute('disabled', true);
    }
  }

  validate() {
    this.isValid = !!this.selectedOption;
    return this.isValid;
  }
}

customElements.define('plan-quiz-question', PlanQuizQuestion);
